<div class="confirm-action-dialog">
  <div class="dialog-accent-bar"></div>

  <div class="dialog-body">
    <h2 mat-dialog-title>{{ title }}</h2>

    <mat-dialog-content>
      <p class="dialog-message">{{ textToDisplay }}</p>

      @if (items && items.length) {
        <mat-list dense class="scrollable-dialog-list">
          @for (item of items; track item) {
            <mat-list-item>{{ item.name }}</mat-list-item>
          }
        </mat-list>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      @if (cancelText) {
        <button mat-stroked-button class="cancel-btn" (click)="choose('cancel')">{{ cancelText }}</button>
      }
      @for (btn of buttons; track btn.value) {
        <button mat-raised-button color="{{ btn.color }}" (click)="choose(btn.value)">{{ btn.text }}</button>
      }
    </mat-dialog-actions>
  </div>
</div>
